module.exports = "https://cdn.thelire.com/ins/resource/pic_pop_loginrequired@3x.a67182f96e1d4e22b0b07780c44476d9.png";